export const QUEUE_EASTER_EGG_EVENT = 'easterEgg/QUEUE_EASTER_EGG_EVENT'
export const CLEAR_EASTER_EGG_EVENT_QUEUE =
  'easterEgg/CLEAR_EASTER_EGG_EVENT_QUEUE'
export const UPDATE_EASTER_EGG_EVENT_QUEUE =
  'easterEgg/UPDATE_EASTER_EGG_EVENT_QUEUE'
